import { isModuleOptionActive, toDrawerOption, } from "@/navigation/activitiesRegistry";
const ROLE_LABELS = {
    president: "Presidente",
    vicepresident: "Vicepresidente",
    treasurer: "Tesorero",
    secretary: "Secretario",
    director: "Director",
    delegate1: "Delegado",
    delegate2: "Delegado",
};
const ROLE_PRIORITY = [
    "president",
    "vicepresident",
    "treasurer",
    "secretary",
    "director",
    "delegate1",
    "delegate2",
];
export const getCpaRoleLabels = (roles) => {
    const ordered = ROLE_PRIORITY.filter((r) => roles.includes(r)).map((r) => ROLE_LABELS[r] || r);
    if (!ordered.length)
        return "Directiva CPA";
    if (ordered.length === 1)
        return `${ordered[0]} CPA`;
    return `${ordered.slice(0, 2).join(" · ")} CPA`;
};
const filterOption = (option, ctx) => {
    if (option.requiresTipoTesoreria !== undefined &&
        option.requiresTipoTesoreria !== "" &&
        ctx.treasuryType !== option.requiresTipoTesoreria) {
        return false;
    }
    if (option.requiresRoles?.length) {
        if (!option.requiresRoles.some((r) => ctx.roles.includes(r)))
            return false;
    }
    return true;
};
/**
 * Menú drawer exclusivo para miembros de directiva CPA.
 * Las opciones salen del Module Registry; la agrupación es de esta vista.
 */
export const buildCpaMenu = (ctx) => {
    const sections = [
        {
            nombre: "Resumen",
            icono: "bi bi-house-door",
            isDirectLink: true,
            opciones: [toDrawerOption("home-summary")],
        },
        {
            nombre: "Inicio CPA",
            icono: "bi bi-speedometer2",
            isDirectLink: true,
            opciones: [toDrawerOption("cpa-home")],
        },
        {
            nombre: "Tesorería",
            icono: "bi bi-wallet2",
            iconTone: "green",
            opciones: [
                toDrawerOption("treasury-payments"),
                toDrawerOption("treasury-funds"),
                toDrawerOption("treasury-validate-payments"),
                toDrawerOption("treasury-incomes"),
                toDrawerOption("treasury-expenses"),
            ],
        },
        {
            nombre: "Organización",
            icono: "bi bi-people",
            iconTone: "indigo",
            opciones: [
                toDrawerOption("courses-boards"),
                toDrawerOption("cpa-tasks"),
                toDrawerOption("surveys"),
                toDrawerOption("asignaciones"),
                toDrawerOption("staff"),
                toDrawerOption("cpa-socios"),
                toDrawerOption("kiosk-admins"),
            ],
        },
        {
            nombre: "Comunidad",
            icono: "bi bi-heart",
            iconTone: "violet",
            opciones: [
                toDrawerOption("school-life"),
                toDrawerOption("sports-delegates"),
                toDrawerOption("commissions"),
                toDrawerOption("brotherhood-bank"),
                toDrawerOption("calendar"),
                toDrawerOption("cpa-classifieds"),
                toDrawerOption("suppliers"),
                toDrawerOption("kiosk"),
            ],
        },
        {
            nombre: "Actividades",
            icono: "bi bi-calendar-event",
            iconTone: "amber",
            opciones: [
                toDrawerOption("fairs"),
                toDrawerOption("kermesses"),
                toDrawerOption("raffles"),
                toDrawerOption("tournaments"),
                toDrawerOption("ticket-events-admin"),
                toDrawerOption("manage-sales"),
                toDrawerOption("manage-donations"),
            ],
        },
        {
            nombre: "Comunicaciones",
            icono: "bi bi-megaphone",
            iconTone: "blue",
            opciones: [
                toDrawerOption("cpa-mass-email"),
                toDrawerOption("sent-notifications"),
                toDrawerOption("website"),
                toDrawerOption("graphic-material"),
                toDrawerOption("galleries"),
            ],
        },
        {
            nombre: "Directiva",
            icono: "bi bi-diagram-3",
            iconTone: "amber",
            opciones: [toDrawerOption("cpa-board")],
        },
    ];
    return sections
        .map((section) => ({
        ...section,
        opciones: section.opciones.filter((op) => filterOption(op, ctx)),
    }))
        .filter((section) => section.isDirectLink || section.opciones.length > 0);
};
export const buildCpaDelegateMenu = (_ctx) => {
    return [];
};
export const isCpaMenuOptionActive = (option, routeName, routePath) => isModuleOptionActive(option, routeName, routePath);
export const findActiveCpaSectionName = (groups, routeName, routePath) => {
    for (const group of groups) {
        if (group.isDirectLink) {
            const op = group.opciones[0];
            if (op && isCpaMenuOptionActive(op, routeName, routePath)) {
                return group.nombre;
            }
            continue;
        }
        for (const op of group.opciones) {
            if (isCpaMenuOptionActive(op, routeName, routePath)) {
                return group.nombre;
            }
        }
    }
    return null;
};
